module.exports = __webpack_public_path__ + "img/chat_avatar_ava.974d6792.png";